import { getHeaderCellStyles } from '»utils/exportColumnsStyles';
import { TrlFormattedMessagePlain } from '»utils/i18n';

export const columns = ({ setFavourite }) => {
  const headerCellStyles = getHeaderCellStyles();

  return [
    {
      title: ' ',
      field: 'dummy',
      width: 5,
      locked: true,
    },
    {
      field: 'isFavourite',
      title: ' ',
      cellTemplate: 'TrlButtonCell',
      type: 'favorite',
      width: '45px',
      setFavourite,
    },
    {
      field: 'space',
    },
    {
      field: 'descr',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-SECURITY' }),
      cellTemplate: 'TrlButtonCell',
      type: 'uppercasecell',
      minWidth: 218,
    },
    {
      field: 'space',
    },
    {
      field: 'minusCell',
      title: ' ',
      cellTemplate: 'TrlButtonCell',
      type: 'minus',
      width: '40px',
    },
    {
      field: 'plusCell',
      title: ' ',
      cellTemplate: 'TrlButtonCell',
      type: 'plus',
      width: '40px',
    },
    {
      field: 'space',
    },
    {
      field: 'symbol',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-TICKER' }),
      cellTemplate: 'TrlButtonCell',
      type: 'uppercasecell',
      minWidth: 130,
    },
    {
      field: 'space',
    },
    {
      field: 'lastPx',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-QUOTE' }),
      cellTemplate: 'TrlButtonCell',
      type: 'numeric',
      decimalDigits: 'roundPrice',
      endDecoratorKey: 'priceRepresentation',
      headerClassName: 'customClassRight',
      className: 'customClassRight',
      minWidth: 120,
      headerCellOptions: headerCellStyles,
    },
    {
      field: 'space',
    },
    {
      title: `-${TrlFormattedMessagePlain({ id: 'TRLT_UI-VALUE' })}-`,
      minWidth: 111,
      headerCellOptions: headerCellStyles,
      children: [
        {
          field: 'nominalValue',
          title: TrlFormattedMessagePlain({ id: 'TRLT_UI-NOMINAL' }),
          cellTemplate: 'TrlButtonCell',
          type: 'numeric',
          decimalDigits: 'roundPrice',
          headerClassName: 'customClassCenter',
          className: 'customClassCenter',
          minWidth: 170,
        },
      ],
    },
    {
      field: 'space',
    },
    {
      field: 'currency',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-CURRENCY' }),
      headerClassName: 'customClassCenter',
      className: 'customClassCenter',
      minWidth: 96,
    },
    {
      field: 'space',
    },
    {
      title: `-${TrlFormattedMessagePlain({ id: 'TRLT_UI-DATE' })}-`,
      minWidth: 200,
      children: [
        {
          field: 'lastDateTime',
          title: TrlFormattedMessagePlain({ id: 'TRLT_UI-LAST_QUOTE_DOT' }),
          cellTemplate: 'TrlButtonCell',
          type: 'datetimeSec',
          headerClassName: 'customClassCenter',
          className: 'customClassCenter',
          minWidth: 200,
        },
      ],
    },
    {
      field: 'space',
    },
    {
      field: 'country',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-MARKET' }),
      cellTemplate: 'TrlButtonCell',
      type: 'flag',
      exchange: 'exchangeDescr',
      minWidth: 170,
    },
    {
      field: 'space',
    },
    {
      field: 'variationPctg',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-DAILY_CHANGE' }),
      cellTemplate: 'TrlButtonCell',
      type: 'numeric',
      decimalDigits: 'roundPrice',
      headerClassName: 'customClassRight',
      className: 'customClassRight',
      visualEffect: 'variationPctg',
      hasVisualEffectAttr: true,
      isMarketStockExchange: true,
      endDecorator: '%',
      minWidth: 111,
      headerCellOptions: headerCellStyles,
    },
    {
      field: 'space',
    },
    {
      field: 'bidPx',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-PURCHASE' }),
      cellTemplate: 'TrlButtonCell',
      type: 'numeric',
      decimalDigits: 'roundPrice',
      headerClassName: 'customClassRight',
      className: 'customClassRight',
      minWidth: 111,
      headerCellOptions: headerCellStyles,
    },
    {
      field: 'space',
    },
    {
      field: 'askPx',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-SALE' }),
      cellTemplate: 'TrlButtonCell',
      type: 'numeric',
      decimalDigits: 'roundPrice',
      headerClassName: 'customClassRight',
      className: 'customClassRight',
      minWidth: 111,
      headerCellOptions: headerCellStyles,
    },
    {
      field: 'space',
    },
    {
      field: 'totalVolumeTraded',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-VOLUME' }),
      cellTemplate: 'TrlButtonCell',
      type: 'numeric',
      decimalDigits: 'roundPrice',
      headerClassName: 'customClassRight',
      className: 'customClassRight',
      minWidth: 111,
      headerCellOptions: headerCellStyles,
    },
    {
      field: 'space',
    },
    {
      field: 'lowPx',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-MINIMUM' }),
      cellTemplate: 'TrlButtonCell',
      type: 'numeric',
      decimalDigits: 'roundPrice',
      headerClassName: 'customClassRight',
      className: 'customClassRight',
      minWidth: 150,
      headerCellOptions: headerCellStyles,
    },
    {
      field: 'space',
    },
    {
      field: 'highPx',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-MAXIMUM' }),
      cellTemplate: 'TrlButtonCell',
      type: 'numeric',
      decimalDigits: 'roundPrice',
      headerClassName: 'customClassRight',
      className: 'customClassRight',
      minWidth: 150,
      headerCellOptions: headerCellStyles,
    },
  ];
};
